import Icon from '@/components/ui/AppIcon';

interface Module {
  id: number;
  title: string;
  completed: boolean;
}

interface ProgressTrackerProps {
  modules: Module[];
  currentModule: number;
}

const ProgressTracker = ({ modules, currentModule }: ProgressTrackerProps) => {
  const completedCount = modules.filter(m => m.completed).length;
  const progressPercentage = (completedCount / modules.length) * 100;

  return (
    <div className="bg-card border border-border rounded-xl p-6 shadow-natural sticky top-20">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-bold text-lg text-text-primary">Your Progress</h3>
        <span className="text-sm font-medium text-text-secondary">{completedCount}/{modules.length}</span>
      </div>
      
      <div className="w-full bg-muted rounded-full h-3 mb-6 overflow-hidden">
        <div
          className="bg-conversion h-full rounded-full transition-all duration-500 ease-organic"
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
      
      <div className="space-y-3">
        {modules.map((module) => (
          <div
            key={module.id}
            className={`flex items-center space-x-3 p-3 rounded-lg transition-all duration-300 ${
              module.id === currentModule
                ? 'bg-primary/10 border border-primary/20'
                : module.completed
                ? 'bg-surface' :'bg-muted/50'
            }`}
          >
            <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center ${
              module.completed
                ? 'bg-conversion text-conversion-foreground'
                : module.id === currentModule
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-text-secondary'
            }`}>
              {module.completed ? (
                <Icon name="CheckIcon" size={16} />
              ) : (
                <span className="text-xs font-bold">{module.id}</span>
              )}
            </div>
            <span className={`text-sm font-medium ${
              module.id === currentModule ? 'text-primary' : 'text-text-secondary'
            }`}>
              {module.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressTracker;